/*
  Winwear — Shop-by-State picker (tile map hover readout + search).

  Lives here rather than in a section's {% javascript %} block on purpose: Shopify wraps
  section JS in `if (__sections__["state-picker"] || Shopify.designMode)`, so it only runs on
  pages that actually render the state-picker section. The State nav dropdown renders the same
  map via snippets/winwear-state-map.liquid on EVERY page, and that guard left it dead —
  no hover readout, no search. Loading it as a normal asset from layout/theme.liquid fixes both.

  Drives any [data-winwear-statepicker] root; init is idempotent via data-wsp-init.
*/
(function () {
  if (window.__winwearStatePickerLoaded) return;
  window.__winwearStatePickerLoaded = true;

  class WinwearStatePicker {
    constructor(root) {
      this.root = root;
      this.dim = root.dataset.dim === 'true';
      this.tiles = Array.from(root.querySelectorAll('.wsp__tile'));
      this.index = this.tiles.map(function (el) {
        return {
          el: el,
          abbr: (el.dataset.abbr || '').toLowerCase(),
          name: (el.dataset.name || '').toLowerCase(),
          disp: el.dataset.name || '',
          href: el.getAttribute('href') || '',
          soon: el.dataset.soon === '1'
        };
      });
      this.readout = root.querySelector('[data-readout]');
      this.readoutDefault = this.readout ? this.readout.textContent : '';
      this.dControl = root.querySelector('[data-search-desktop]');
      this.dBtn = root.querySelector('[data-search-open]');
      this.dInput = root.querySelector('[data-search-input-d]');
      this.dClose = root.querySelector('[data-search-close]');
      this.dDrop = root.querySelector('[data-results-d]');
      this.mInput = root.querySelector('[data-search-input-m]');
      this.mResults = root.querySelector('[data-results-m]');
      this.bind();
    }

    bind() {
      const self = this;
      this.index.forEach(function (it) {
        it.el.addEventListener('mouseenter', function () { self.setReadout(it); });
      });
      // Clear once when the pointer leaves the whole map, not per tile: a per-tile
      // mouseleave fires clear->set on every tile-to-tile move and makes the readout flicker.
      const map = this.root.querySelector('.wsp__map');
      if (map) map.addEventListener('mouseleave', function () { self.clearReadout(); });
      if (this.dBtn) this.dBtn.addEventListener('click', function () {
        self.dControl.classList.add('is-open');
        if (self.dInput) self.dInput.focus();
      });
      if (this.dClose) this.dClose.addEventListener('click', function () {
        self.dControl.classList.remove('is-open');
        if (self.dInput) self.dInput.value = '';
        self.setQuery('', 'd');
      });
      if (this.dInput) {
        this.dInput.addEventListener('input', function () { self.setQuery(self.dInput.value, 'd'); });
        this.dInput.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && self.dControl && !self.dControl.classList.contains('is-static')) {
            self.dControl.classList.remove('is-open');
            self.dInput.value = '';
            self.setQuery('', 'd');
          }
        });
      }
      if (this.mInput) this.mInput.addEventListener('input', function () { self.setQuery(self.mInput.value, 'm'); });
      if (this.dControl && !this.dControl.classList.contains('is-static')) {
        document.addEventListener('click', function (e) {
          if (!self.dControl.contains(e.target)) self.dControl.classList.remove('is-open');
        });
      }
    }

    match(q) {
      q = (q || '').trim().toLowerCase();
      if (!q) return [];
      return this.index
        .filter(function (it) { return it.name.indexOf(q) > -1 || it.abbr === q; })
        .sort(function (a, b) { return a.disp.localeCompare(b.disp); });
    }

    setReadout(it) {
      if (!this.readout) return;
      this.readout.textContent = it.soon ? (it.disp + ' — coming soon') : ('Shop the ' + it.disp + ' collection');
      this.readout.classList.add('is-hot');
    }
    clearReadout() {
      if (!this.readout) return;
      this.readout.textContent = this.readoutDefault;
      this.readout.classList.remove('is-hot');
    }

    resultsHTML(list) {
      if (!list.length) return '<div class="wsp__empty">No match — try another spelling.</div>';
      return list.slice(0, 8).map(function (it) {
        const ab = it.abbr.toUpperCase();
        if (it.soon) {
          return '<span class="wsp__result wsp__result--soon"><span class="wsp__result-ab">' + ab + '</span><span class="wsp__result-nm">' + it.disp + '</span><span class="wsp__result-soon">Soon</span></span>';
        }
        return '<a class="wsp__result" href="' + it.href + '"><span class="wsp__result-ab">' + ab + '</span><span class="wsp__result-nm">' + it.disp + '</span><span class="wsp__result-arrow">&rarr;</span></a>';
      }).join('');
    }

    setQuery(q, mode) {
      const has = (q || '').trim().length > 0;
      const qq = (q || '').trim().toLowerCase();
      const list = this.match(q);
      if (this.dim) {
        this.index.forEach(function (it) {
          const m = !has || it.name.indexOf(qq) > -1 || it.abbr === qq;
          it.el.classList.toggle('is-dim', has && !m);
        });
      }
      if (mode === 'd') {
        if (this.dDrop) this.dDrop.innerHTML = has ? this.resultsHTML(list) : '';
        if (this.dControl) this.dControl.classList.toggle('has-results', has);
      } else {
        if (this.mResults) this.mResults.innerHTML = has ? this.resultsHTML(list) : '';
        this.root.classList.toggle('is-msearch', has);
      }
    }
  }

  function initWinwearStatePicker(scope) {
    (scope || document).querySelectorAll('[data-winwear-statepicker]').forEach(function (el) {
      if (!el.dataset.wspInit) { el.dataset.wspInit = '1'; new WinwearStatePicker(el); }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initWinwearStatePicker(); });
  document.addEventListener('shopify:section:load', function (e) { initWinwearStatePicker(e.target); });

})();
